module.exports = __webpack_public_path__ + "img/chartTab.7e2b10ee.png";